<!-- eslint-disable prettier/prettier -->
<template>
  <div class="h5-list">
    <!-- 非微信/支付宝环境提示 -->
    <div v-if="!isWeChatOrAlipay" class="env-tip">
      <div class="tip-content">
        <img class="tip-icon" :src="require('@/assets/images/log.png')" alt="logo" />
        <p>请使用微信或支付宝扫码</p>
      </div>
    </div>
    
    <!-- 微信/支付宝环境下显示内容 -->
    <template v-else>
      <!-- 入园码引导 -->
      <div class="ticket-guide" @click="showPhoneDialog = true">
        <el-icon class="guide-icon"><Pointer /></el-icon>
        <span class="guide-text">查看入园码</span>
      </div>
      
      <div class="h5-search">
        <el-input
          v-model="state.params.Params.Key"
          placeholder="关键字"
          clearable
          @clear="onClear"
          @keyup.enter="onSearch"
        />
        <el-button type="primary" class="h5-search-btn" @click="onSearch">查询</el-button>
      </div>
      
      <!-- 手机号码输入弹框 -->
      <el-dialog
        v-model="showPhoneDialog"
        title="请输入手机号码"
        width="300px"
      >
        <el-input
          v-model="phoneNumber"
          placeholder="请输入手机号码"
          type="number"
          maxlength="11"
          @keyup.enter="onPhoneSubmit"
        />
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="showPhoneDialog = false">取消</el-button>
            <el-button type="primary" @click="onPhoneSubmit">完成</el-button>
          </span>
        </template>
      </el-dialog>

    <div class="h5-cards" v-loading="!Array.isArray(state.tableData)">
      <div
        class="h5-card"
        v-for="item in state.tableData || []"
        :key="item.Id"
      >
        <div class="row between">
          <div class="status" :style="{ color: item.IsQy ? '#080' : '#f00' }">{{ item.IsQy ? '售卖中' : '停售' }}</div>
          <div class="pl">{{ item.PlMc }}</div>
        </div>

        <div class="titleh5">
          <span class="mc">{{ item.Mc }}</span>
        </div>

        <div class="row info">
          <span class="label">目的地/地址：</span>
          <span class="val">{{ (item.Mdd || '-') + (item.Dz ? ('，' + item.Dz) : '') }}</span>
        </div>

        <div class="row info">
          <span class="label">联系电话：</span>
          <span class="val">{{ item.Dh || '-' }}</span>
        </div>

        <div class="row info intro" v-if="item.Jj">
          <span class="label">商品简介：</span>
          <span class="val">{{ item.Jj }}</span>
        </div>
        <div class="order">
          <el-button type="primary" size="small" @click.stop="onOrder(item)">下单</el-button>
        </div>
      </div>
    </div>

      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.PageIndex"
        @onLoad="(pageIndex) => { state.params.PageIndex = pageIndex; onLoad(); }"
      />
    </template>
  </div>
  
</template>

<script>
/* eslint-disable prettier/prettier */
import { reactive, computed, onMounted, getCurrentInstance, ref } from "vue";
import { shangpin_list_an } from "@/http/api";
import { useRoute } from "vue-router";
import { dayjs } from "element-plus";
import { Pointer } from "@element-plus/icons-vue";

class InitFormData {
  params = {
    PageSize: 10,
    PageIndex: 1,
    Params: {},
    Order: "Cjsj",
    Asc: false,
  };
}

export default {
  setup() {
    const route = useRoute();
    const state = reactive(new InitFormData());
    const query = reactive({});
    const showPhoneDialog = ref(false);
    const phoneNumber = ref('');
    const { proxy } = getCurrentInstance();
    
    // 检测是否在微信或支付宝环境中
    const isWeChatOrAlipay = computed(() => {
      const userAgent = navigator.userAgent.toLowerCase();
      // 检测是否为微信环境
      const isWeChat = /micromessenger/.test(userAgent);
      // 检测是否为支付宝环境
      const isAlipay = /alipayclient/.test(userAgent);
      return isWeChat || isAlipay;
    });

    const onLoad = () => {
      delete state.tableData;
      console.log(query.ph+','+query._t)
      shangpin_list_an(state.params,query.ph,query._t).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    const onClear = () => {
      delete state.params.Params.Key;
      onLoad();
    };

    const onSearch = () => {
      if (state.params?.Params?.Key === "") {
        delete state.params.Params.Key;
      }
      state.params.PageIndex = 1;
      onLoad();
    };

    const can = (q) => {
      const u = proxy.$store.state.loginUser || {};
      return u?.IsAdmin || u?.Qxs?.includes(q);
    };

    const canSeeActions = computed(() => {
      const u = proxy.$store.state.loginUser || {};
      return !!(u?.IsAdmin || (u?.Qxs && u.Qxs.some((x) => x.startsWith('B_ShangPin_List_'))));
    });

    const onManage = (row) => {
      proxy.$store.commit("openMenu", {
        path: "ShangPinDetail",
        title: "商品详情",
        data: { id: row.Id },
        refresh: true,
      });
    };

    const onEdit = (row) => {
      proxy.$store.commit("openMenu", {
        path: "ShangPinCompile",
        title: "编辑商品",
        data: { id: row.Id },
        refresh: true,
      });
    };

    const onOrder = (row) => {
      proxy.$router.push({ name: 'H5ShangPinOrder',query: { ph:query.ph, _t: query._t }, params: { id: row.Id } });
    };
    
    const onPhoneSubmit = () => {
      if (phoneNumber.value && phoneNumber.value.length === 11) {
        showPhoneDialog.value = false;
        // 跳转到H5TicketShortLink页面，并传递手机号码和其他必要参数
        proxy.$router.push({ 
          name: 'H5TicketShortLink',
          query: { 
            ph: query.ph, 
            _t: query._t
          },
          params: { code: phoneNumber.value }
        });
      } else {
        proxy.$message.warning('请输入预定的手机号码');
      }
    };

    onMounted(() => {
      state.params.Params.Date = dayjs().format("YYYY-MM-DD 00:00:00");
      query.ph = route.query.ph; 
      query._t = route.query._t; 
      
      // 只有在微信或支付宝环境下才加载数据
      if (isWeChatOrAlipay.value) {
        onLoad();
      }
    });

    return {
      state,
      onLoad,
      onClear,
      onSearch,
      onManage,
      onEdit,
      can,
      canSeeActions,
      onOrder,
      onPhoneSubmit,
      showPhoneDialog,
      phoneNumber,
      isWeChatOrAlipay,
      Pointer,
    };
  },
};
</script>

<style>
.h5-list {
  padding: 10px;
  height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.ticket-guide {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 10px;
  cursor: pointer;
}

.guide-icon {
  font-size: 24px;
  margin-right: 8px;
  color: #409EFF;
  transform: scaleX(-1);
  animation: wave 2s infinite;
}

.guide-text {
  font-size: 14px;
  color: #409EFF;
}

@keyframes wave {
  0%, 100% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(15deg);
  }
}

.h5-search {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}

.h5-search-btn {
  white-space: nowrap;
}

.h5-cards {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.h5-card {
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 12px;
  background: #fff;
}

.row {
  display: flex;
  align-items: flex-start;
}

.between {
  justify-content: space-between;
}

.status { font-size: 12px; }
.pl { font-size: 12px; color: #909399; }

.titleh5 { margin: 6px 0; }
.titleh5 .mc { font-weight: 600; color: #303133; font-size: 16px;}
.titleh5 .gys { color: #a2a2a2; margin-left: 6px; }

.info { font-size: 12px; color: #606266; line-height: 18px; }
.info .label {
  color: #909399;
  margin-right: 4px;
  width: 90px;
  flex-shrink: 0;
  text-align: left;
  white-space: nowrap;
}
.info .val {
  flex: 1;
  word-break: break-word;
}
.intro .val { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }

.meta { margin-top: 8px; font-size: 12px; color: #a2a2a2; justify-content: space-between; }

.order { margin-top: 10px; text-align: right; }

.actions { margin-top: 8px; display: flex; gap: 12px; }

@media (min-width: 768px) {
  .h5-list { max-width: 720px; margin: 0 auto; }
}

/* 环境提示样式 */
.env-tip {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8f8f8;
}

.tip-content {
  text-align: center;
  padding: 40px 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  max-width: 300px;
}

.tip-icon {
  width: 100px;
  height: 100px;
  object-fit: contain;
  margin-bottom: 20px;
}

.tip-content p {
  font-size: 16px;
  color: #606266;
  line-height: 1.5;
}

/* 确保容器高度正常 */
.h5-list {
  min-height: 100vh;
}
</style>


